import { queryOptions, useQueryClient } from '@tanstack/react-query';
import { clientService } from 'stores/client-store/client-store.ts';
import { ExposureFetchRequest, ExposureResponseViewModel } from 'bff';
import { secondsToMilliseconds } from 'date-fns';
import { isNil } from 'lodash';

export const exposureKeys = {
  base: () => ['proposal-exposure'] as const,
  getExposure: (proposalId: number) => ['proposal-exposure', proposalId] as const
};

export const getProposalExposureOptions = (exposureRequest: ExposureFetchRequest) => {
  const { exposureApi } = clientService.getApiClient();

  return queryOptions({
    queryKey: exposureKeys.getExposure(exposureRequest.proposalId),
    queryFn: () => exposureApi.exposureFetch(exposureRequest),
    select: (response) => mapProposalIdForExposure(response.data!, exposureRequest.proposalId),
    staleTime: secondsToMilliseconds(30)
  });
};

export const useInvalidateExposureDetails = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: exposureKeys.base(),
      refetchType: 'all'
    });
};

const mapProposalIdForExposure = (data: ExposureResponseViewModel, proposalId: number) => {
  if (
    data.portfolioExposure?.actualAssetClassExposure !== undefined &&
    data.portfolioExposure?.actualAssetClassExposure?.length > 0
  ) {
    data.portfolioExposure.actualAssetClassExposure =
      data.portfolioExposure.actualAssetClassExposure.map((exposure) => {
        if (isNil(exposure.id)) {
          exposure.id = `${proposalId}`;
        }
        return exposure;
      });
  }

  if (
    data.portfolioExposure?.actualRegionalExposure !== undefined &&
    data.portfolioExposure?.actualRegionalExposure?.length > 0
  ) {
    data.portfolioExposure.actualRegionalExposure =
      data.portfolioExposure.actualRegionalExposure.map((exposure) => {
        if (isNil(exposure.id)) {
          exposure.id = `${proposalId}`;
        }
        return exposure;
      });
  }

  if (
    data.portfolioExposure?.infrastrucureExposure !== undefined &&
    data.portfolioExposure?.infrastrucureExposure?.length > 0
  ) {
    data.portfolioExposure.infrastrucureExposure = data.portfolioExposure.infrastrucureExposure.map(
      (exposure) => {
        if (isNil(exposure.id)) {
          exposure.id = `${proposalId}`;
        }
        return exposure;
      }
    );
  }

  return data;
};
